TS.ns('WL');

WL.financialProductSelectModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var financialProductList = me.getDomainProperty('FinancialProductList1_Property');
        if (financialProductList) {

            financialProductList.executeDefault = function () {
                var financialProductList = me.getDomainProperty('FinancialProductList1_Property');
                var ProductId = financialProductList.SelectedItem().ProductId();
                var ProductName = financialProductList.SelectedItem().Name(); 
                me.performServerCommand('Save', true, { ProductId: ProductId, ProductName: ProductName });
            }
        }

    }
});